import { useDispatch } from "react-redux";
import { StyledModal } from "../global-modals/global-modals.styles";
import { selectTopUpOrgId } from "../../store/global-modals/global-modals.selector";
import { useSelector } from "react-redux";
import { useState } from "react";
import loader from "../../assets/images/loader.svg";
import { setTopUpOrgId } from "../../store/global-modals/global-modals.reducer";
import { PaymentDown } from "../payment-down/payment-down.component";
import { contactUs } from "../../utils/utils";

export const TopUpModal = () => {
  const dispatch = useDispatch();
  const topUpOrgId = useSelector(selectTopUpOrgId);
  const toggle = () => {
    dispatch(setTopUpOrgId(topUpOrgId ? 0 : topUpOrgId));
  };
  const [loading, setLoading] = useState(true);

  return (
    <StyledModal
      onCancel={toggle}
      open={!!topUpOrgId}
      footer={null}
      width="400px"
      centered
      title={"Add Pulse Minutes"}
      destroyOnClose
    >
      {false ? (
        <PaymentDown
          problem="Top up recharge is down"
          alternative="Please try paying via App or contact Whatsapp Support"
          onContact={() => {
            contactUs("I need help with recharging Outgoing Top Up minutes");
          }}
        />
      ) : (
        <div
          style={{
            height: "100%",
            width: "100%",
            overflow: "auto",
            ...(loading
              ? {
                  backgroundImage: `url(${loader})`,
                  backgroundPosition: "center",
                  backgroundSize: "center",
                  backgroundRepeat: "no-repeat",
                }
              : {}),
          }}
        >
          <iframe
            onLoad={() => setLoading(false)}
            id="top-up-i-frame"
            title="SuperfoneTopUpPaymentFlow"
            src={`${process.env.REACT_APP_USER_URL}/payments/top-up?referred=true&referredOrgId=${topUpOrgId}`}
            width="100%"
            height="100%"
          />
        </div>
      )}
    </StyledModal>
  );
};
